import { render } from "./not-found.vue?vue&type=template&id=457ce9d0&scoped=true&ts=true"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"

import "./not-found.vue?vue&type=style&index=0&id=457ce9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457ce9d0"]])

export default __exports__